<template>
  <div v-if="sd.panels_meta.widgets !== undefined" class="ms ms--regular" :class="[index === activeSlide ? 'active' : 'inactive', sd.slide_color === 'green' ? 'bg-color--dark' : '']" ref="parent" :data-id="index" @scroll="checkScroll()">
        <div class="ms__wrap c c--content--pad r pad--h v--40">
            <div class="ms__top">

                <div v-if="sd.feature_image" class="ms__image" style="overflow: hidden;">
                    <img :src="sd.feature_image[0]" :width="sd.feature_image[1] / 2" :height="sd.feature_image[2] / 2"/>
                </div>
                <div class="ms__content v--20">
                    <div v-for="(instance, index) in sd.panels_meta.widgets" :key="instance._sow_form_id + '-' + index">
                        <PanelText v-if="instance.panels_info.class === 'Text_Panel'" :instance="instance" :siloData="siloData" :active="active" @updateState="updateState"/>
                        <PanelSession v-if="instance.panels_info.class === 'Session_Panel'" :instance="instance" :topicTitle="sd.ancestors[1].title"/>
                        <PanelVideoTeam v-if="instance.panels_info.class === 'Video_Team_Panel'" :instance="instance" :siloData="siloData" :active="active" @next="next"/>
                        <PanelAudio v-if="instance.panels_info.class === 'Audio_Panel'" :instance="instance" :siloData="siloData" :active="active" :pauseVideo="pauseVideo" :isLast="isLast" @playingVideo="playingVideo" @next="next" @close="$emit('close')"/>
                        <PanelShowHide v-if="instance.panels_info.class === 'Show_Hide_Panel'" :instance="instance" :siloData="siloData"/>
                        <PanelForm v-if="instance.panels_info.class === 'Form'" :instance="instance" :siloData="siloData" :slide="slides[0]" :active="active" :pauseVideo="pauseVideo" :isLast="isLast" @next="next" @processing="setProcessing" @refreshData="refreshData" @setNextOnRefresh="setNextOnRefresh" @playingVideo="playingVideo" @toMenu="$emit('toMenu')" />
                        <PanelAffirmation v-if="instance.panels_info.class === 'Affirmation_Panel'" :instance="instance" :siloData="siloData" :active="active"/>
                        <PanelStringCheck v-if="instance.panels_info.class === 'String_Check_Panel'" :instance="instance" :siloData="siloData" :active="active"/>
                        <PanelEmbed v-if="instance.panels_info.class === 'Embed_Panel'" :instance="instance" :active="active" :pauseVideo="pauseVideo" :isLast="isLast" v-bind:allowNext="true" @next="next" @playingVideo="playingVideo" @close="$emit('close')"/>
                        <PanelEmbeds v-if="instance.panels_info.class === 'Embeds_Panel'" :instance="instance" :active="active" :appState="appState" :pauseVideo="pauseVideo" :isLast="isLast" v-bind:allowNext="true" @next="next" @playingVideo="playingVideo" @close="$emit('close')"/>
                        <PanelVariable v-if="instance.panels_info.class === 'Variable_Panel'" :instance="instance" :siloData="siloData"/>
                        <Forwarder v-if="instance.panels_info.class === 'Forwarder'" :instance="instance" :siloData="siloData" @next="next" />

                        <!-- Conditional panel needs *everything* attached to it -->
                        <Conditional
                            v-if="instance.panels_info.class === 'Conditional'"
                            :instance="instance"
                            :siloData="siloData"
                            :pauseVideo="pauseVideo"
                            :active="active"
                            :slide="slides[0]"
                            @next="next"
                            @prev="prev"
                            @processing="setProcessing"
                            @refreshData="refreshData"
                            @setNextOnRefresh="setNextOnRefresh"
                            @playingVideo="playingVideo"
                        />

                        <!-- Multi-conditional panel needs *everything* attached to it -->
                        <Mconditional
                            v-if="instance.panels_info.class === 'Mconditional'"
                            :instance="instance"
                            :siloData="siloData"
                            :pauseVideo="pauseVideo"
                            :active="active"
                            :slide="slides[0]"
                            @next="next"
                            @prev="prev"
                            @processing="setProcessing"
                            @refreshData="refreshData"
                            @setNextOnRefresh="setNextOnRefresh"
                            @playingVideo="playingVideo"
                        />

                        <Uconditional
                            v-if="instance.panels_info.class === 'Ultra_Conditional'"
                            :instance="instance"
                            :siloData="siloData"
                            :pauseVideo="pauseVideo"
                            :active="active"
                            :slide="slides[0]"
                            :isLast="isLast"
                            @next="next"
                            @prev="prev"
                            @processing="setProcessing"
                            @refreshData="refreshData"
                            @setNextOnRefresh="setNextOnRefresh"
                            @playingVideo="playingVideo"
                            @toMenu="$emit('toMenu')"
                        />

                    </div>
                </div>
            </div>
            <div class="ms__buttons r r--halign-center">

                <template v-if="slides.length === 1">
                    <!-- Topic finish button (Topics menu) -->
                    <button v-if="!hideButton" class="ms__home btn btn--solid" @click="$emit('toMenu')" aria-label="Return to topics menu">Finish</button>
                </template>
                <template v-else>
                    <!-- regular next button -->
                    <button v-if="!isLast && !hideButton" class="ms__next btn btn--solid" @click="next" v-text="isFirst? 'Start' : 'Next'">Next</button>

                    <!-- Topic finish button (Topics menu) -->
                    <button v-if="isLastAndIsModule && !hideButton" class="ms__home btn btn--solid" @click="$emit('toMenu')" aria-label="Return to topics menu">Finish</button>
                </template>

                <!--
                <button v-if="!isLastAndIsModule && isLast && !hideButton" class="ms__home btn btn--solid" @click="$emit('close')">Finish</button>
                -->


                <!-- Bonus Topics finish button (Bonus topics menu) -->
                <button v-if="isLastAndIsBonus && !isLastAndIsBonusAndIsSlipHelp && !hideButton" class="ms__home btn btn--solid" @click="$emit('toMenu')" aria-label="Return to bonus topics menu">Finish</button>

                <!-- Slip Help only finish button (Homescreen) -->
                <button v-if="isLastAndIsBonus && isLastAndIsBonusAndIsSlipHelp && !hideButton" class="ms__home btn btn--solid" @click="$emit('close')" aria-label="Return to home screen">Finish</button>

                <!-- Practice finish button (Practice menu) -->
                <button v-if="isLastAndIsPractice && !hideButton" class="ms__home btn btn--solid" @click="$emit('toMenu')" aria-label="Return to practice menu">Finish</button>

            </div>
        </div>
        <!--
        <div class="ms__bg" :class="isLastAndIsModule ? 'ms__bg--blue' : ''"></div>
        -->

        <!-- ADMIN -->
        <div v-if="this.siloData.user.role === 'administrator'" class="admin" :data-hidden="hideAdmin.toString()">
            <div class="admin__wrap">
                <span class="admin__slide-name">Slide {{ index + 1 }}, {{ sd.slug }}</span>
                <a class="admin__edit" data-barba-prevent="all" :href="`/wp-admin/post.php?post=${sd.ID}&action=edit`">Edit</a>
                <a class="admin__new" data-barba-prevent="all" :href="`/wp-admin/post-new.php?post_type=module`">Add New</a>
                <a class="admin__all" data-barba-prevent="all" :href="`/wp-admin/edit.php?post_type=module`">View All</a>
                <button @click="next">Next</button>
                <button @click="prev">Prev</button>
                <button @click="$emit('close')">Home</button>
                <button class="admin__toggle" @click="toggleAdmin">X</button>
            </div>
        </div>
        <!-- ADMIN -->

  </div>
</template>

<script>
import PanelText from "@c/panels/PanelText.vue";
import PanelSession from "@c/panels/PanelSession.vue";
import PanelVideoTeam from "@c/panels/PanelVideoTeam.vue";
import PanelAudio from "@c/panels/PanelAudio.vue";
import PanelForm from "@c/panels/PanelForm.vue";
import PanelAffirmation from "@c/panels/PanelAffirmation.vue";
import PanelEmbed from "@c/panels/PanelEmbed.vue";
import PanelEmbeds from "@c/panels/PanelEmbeds.vue";
import PanelVariable from "@c/panels/PanelVariable.vue";
import PanelShowHide from "@c/panels/PanelShowHide.vue";
import Conditional from "@c/panels/Conditional.vue";
import Mconditional from "@c/panels/Mconditional.vue";
import Forwarder from "@c/panels/Forwarder.vue";
import Icon from "@c/Icon.vue";
import Uconditional from "@c/panels/Uconditional.vue";
import PanelStringCheck from "@c/panels/PanelStringCheck.vue";
export default {
    //name: this.index,
    components: {
        PanelText,
        PanelSession,
        PanelVideoTeam,
        PanelAudio,
        PanelForm,
        PanelAffirmation,
        PanelEmbed,
        PanelEmbeds,
        PanelVariable,
        PanelShowHide,
        Conditional,
        Mconditional,
        Forwarder,
        Icon,
        Uconditional,
        PanelStringCheck,
    },
	props: {
		sd: Object, // aka 'slide data'
        index: Number, // the index of this slide
        slides: Array, // all slide data
        siloData: Object,
        activeSlide: Number,
        active: Boolean,
        appState: String,
	},
    data() {
        return {
            pauseVideo: true,
            hideAdmin: false,
        } 
    },
    mounted() {
        // Dynamically set name of component (for debugging purposes)
        this.$options.name = `ModuleSlide ${this.index + 1}`;
    },
    watch: {
        active() {
            //this.activeCheck();
            // Reset slide scroll to 0
            this.resetScroll();
        },
        appState() {
            if (this.appState !== 'module' || this.appState !== 'module-intro') {
                this.pauseVideo = true;
            }
        }
    },
    computed: {
        topicTitle() {
            return this.sd.ancestors[1].title;
        },
        // Adds 1 to index, since index is always based on 0
        actualIndex() {
            return this.index + 1;
        },
        isLast() {
            return this.actualIndex === this.slides.length ? true : false;
        },
        isFirst() {
            return this.actualIndex === 1 ? true : false;
        },
        isLastAndIsModule() {
            return this.actualIndex === this.slides.length && this.sd.type === 'module' ? true : false;
        },
        isLastAndIsBonus() {
            return this.actualIndex === this.slides.length && this.sd.type === 'bonus' ? true : false;
        },
        isLastAndIsBonusAndIsSlipHelp() {
            return this.actualIndex === this.slides.length && this.sd.type === 'bonus' && this.slides[0].slug === 'slip-help' ? true : false;
        },
        isFirstAndIsPractice() {
            return this.actualIndex === 1 && this.sd.type === 'practice' ? true : false;
        },
        isLastAndIsPractice() {
            return this.actualIndex === this.slides.length && this.sd.type === 'practice' ? true : false;
        },
        // Check to see if the slide has a form panel or any other one where we need to hide the button
        hideButton() {
            let returned = false;

            // Loop through panel widgets
            this.sd.panels_meta.widgets.forEach(instance => {
                // If we find a form panel, set the return to true
                if (instance.panels_info.class === 'Form' || instance.panels_info.class === 'Video_Team_Panel' || instance.panels_info.class === 'Audio_Panel' || instance.panels_info.class === 'Embeds_Panel' || instance.panels_info.class === 'Conditional' || instance.panels_info.class === 'Mconditional' || instance.panels_info.class === 'Ultra_Conditional') {
                    returned = true;
                }
                // Hide the button if it's an embed panel AND it's required, otherwise use the module button
                if (instance.panels_info.class === 'Embed_Panel' && instance.required === true) {
                    returned = true;
                }
            });

            return returned;
        },
    },
    methods: {
        /*
        activeCheck() {
            if (this.active === true) {
                //console.log('MODULE SLIDE, THIS SLIDE IS NOW ACTIVE');
            }
        },
        */
        next() {
            // emit next event to parent
            this.$emit('next');
            this.pauseVideo = true;
        },
        prev() {
            // emit prev to parent
            this.$emit('prev');
            this.pauseVideo = true;
        },
        setProcessing(state) {
            //console.log('setting processing (module slide)');
            this.$emit('processing', state);
        },
        refreshData(onComplete = null) {
            //console.log('refreshing data (module slide)');
            this.$emit('refreshData', onComplete);
        },
        setNextOnRefresh() {
            //console.log('SETTING NEXT ON REFRESH setting next on refresh (module slide)');
            this.$emit('setNextOnRefresh');
            this.pauseVideo = true;
        },
        // Emitted when playing a video
        playingVideo() {
            console.log("MODULE SLIDE: turning off pause video");
            //console.log('setting playing video to false!');
            this.pauseVideo = false;
        },
        updateState(newState) {
            //console.log('updating state in moduleslide');
            this.$emit('updateState', newState);
        },
        toggleAdmin() {
            this.hideAdmin = !this.hideAdmin;
        },
        // Check to see if we've scrolled in the parent frame
        checkScroll() {
            if (this.$refs.parent === undefined) { return; }

            // 88 is the height of the header area
            if (this.$refs.parent.scrollTop > 88) {
                this.$refs.parent.dataset.scrolled = true;
            } else {
                this.$refs.parent.dataset.scrolled = false;
             };
       },
       // Reset the scroll back to 0
       resetScroll() {
            this.$refs.parent.scrollTop = 0;
       },
    }
}
</script>

<style lang="scss">
@import "@s/_mixins.scss";
@import "@s/_vars.scss";
.ms {
    height: 100%;
    //padding-top: var(--height--header-m);
    overflow-y: scroll;
    overflow-x: hidden;
    //padding-top: env(safe-area-inset-top);

    &[data-scrolled="true"] {
        .ms__wrap {
            &:before {
                opacity: 1;
            }
        }
    }
}
.ms__image {
    display: block;
    margin-inline: auto;
    margin-bottom: rem(20px);
    > * {
        display: block;
        margin-inline: auto;
    }
}
.ms__nav {
    height: $header_height_m;
}
.ms__wrap {
    z-index: 1;
    /*
    &:before {
        content: "";
        display: block;
        width: 200vw;
        height: 200vw;
        z-index: 0;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: red;
    }
        */
    &:before {
        content: "";
        display: block;
        width: 100%;
        height: rem(10px);
        //background: #095656;
        background:     radial-gradient(
            farthest-side at 50% 0,
            rgba(var(--color-sp-emerald-rgb), 0.2),
            rgba(var(--color-sp-emerald-rgb), 0),
            ) center top;
        position: sticky;
        top: 0;
        left: 0;
        right: 0;
        opacity: 0;
        transition: opacity 0.15s;
        z-index: 2;
    }
}
.ms__bg {
    background-color: var(--color-white);
    &--blue {
        background-color: var(--color-navy-blue);
    }
}
.ms__nav__title {
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    width: 100%;
    pointer-events: none;
}
.ms__nav__wrap {
    color: var(--color-blue-button-dark);
}
.ms__buttons {
    padding-bottom: rem(60px);
}
</style>

<style lang="scss">
@import "@s/_mixins.scss";
@import "@s/_vars.scss";
.ms__wrap {
        padding-bottom: rem(120px);

    //padding-top: rem(20px);
    
    //padding-bottom: rem(100px);
    /* TODO: Make this extend full left and full right
    &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background-color: var(--color-white);
    }
    */
}
.ms--regular {
    .ms__wrap {
        //background-color: var(--color-white);
    }
}
.ms__content {

}
.ms__close {

}
.admin {
    position: fixed;
    inset: auto 0 4vh 0;
    width: 100%;
    max-width: rem(1200px);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    margin-top: rem(45px);
    z-index: $z_top;
    margin-inline: auto;
    &[data-hidden="true"] {
        .admin__wrap {
            > *:not(.admin__toggle) {
                display: none;
            }
            > * + * {
                &:before {
                    display: none;
                }
            }
        }
    }
}
.admin__wrap {
    padding: rem(10px) rem(16px);
    background-color: #eee;
    border: 1px solid #bbb;
    border-radius: 8px;
    font-size: rem(12px) !important;

    a, button{
        color: #777 !important;
        text-decoration: underline !important;
    }
    > * {
        color: #777;
    }
    > * + * {
        &:before {
            content: "|";
            display: inline-block;
            margin-inline: rem(7px) rem(10px);
            color: #bbb;
        }
    }
}
.ms__back {
    color: var(--color-sp-jade);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    &:before {
        content: "";
        display: block;
        width: 6px;
        height: 10px;
        background-image: svg-url($icon_back_arrow);
        background-repeat: no-repeat;
        background-size: cover;
    }
}

.ms__next {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    &:after {
        content: "";
        display: block;
        width: 6px;
        height: 11px;
        top: 1px;
        background-image: svg-url($icon_next_arrow);
        background-repeat: no-repeat;
        background-size: cover;
    }
}


</style>